import React from 'react';
import { SHELL_WHITE, alpha } from '../../../theme/colors';
import ProtocolMockCards from './ProtocolMockCards';
import HealthProfileCard from './HealthProfileCard';
import SignalGrid from './SignalGrid';
import WeightInterpretationCard from './WeightInterpretationCard';

// alignment per overlay: 'end-start' (protocols hug the bottom-left, like the
// real Tracker screen) vs 'center' (the other three read as a single focal
// object floating mid-card)
const OVERLAY_ALIGN = {
  protocols: { justifyContent: 'flex-end', alignItems: 'flex-start' },
  healthProfile: { justifyContent: 'center', alignItems: 'center' },
  signalGrid: { justifyContent: 'center', alignItems: 'center' },
  weight: { justifyContent: 'center', alignItems: 'center' },
};

const OVERLAYS = {
  protocols: () => (
    <div style={{ width: 353 }}>
      <ProtocolMockCards />
    </div>
  ),
  healthProfile: () => <HealthProfileCard />,
  signalGrid: () => <SignalGrid variant="desktop" />,
  weight: () => <WeightInterpretationCard />,
};

const FeatureCardDesktop = ({ feature }) => {
  const Overlay = OVERLAYS[feature.overlay];
  const align = OVERLAY_ALIGN[feature.overlay];

  return (
    <div
      style={{
        position: 'relative',
        aspectRatio: '644 / 580',
        borderRadius: 16,
        border: `1px solid ${alpha('sandy', 0.2)}`,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: 36,
        boxSizing: 'border-box',
        backgroundImage: feature.tint
          ? `linear-gradient(rgba(0,0,0,${feature.tint}), rgba(0,0,0,${feature.tint})), url(${feature.image})`
          : `url(${feature.image})`,
        backgroundSize: 'cover',
        backgroundPosition: '50%',
      }}
    >
      <div style={{ fontFamily: 'Instrument Serif', fontStyle: 'italic', fontSize: 13, color: SHELL_WHITE, opacity: 0.7 }}>
        {feature.number}
      </div>
      <div style={{ fontFamily: 'DM Sans', fontSize: 22, fontWeight: 600, color: SHELL_WHITE, marginTop: 4 }}>{feature.title}</div>
      <div style={{ fontFamily: 'DM Sans', fontSize: 14, lineHeight: 1.5, color: SHELL_WHITE, opacity: 0.9, marginTop: 8, maxWidth: 570 }}>
        {feature.description}
      </div>

      <div style={{ display: 'flex', flex: 1, marginTop: 20, ...align }}>
        <Overlay />
      </div>
    </div>
  );
};

export default FeatureCardDesktop;
